import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as DebanensiteIcon } from './debanensite.svg';

export const Debanensite = IconHOC(DebanensiteIcon);
